import { useFormikContext } from "formik";
import { useTranslations } from "use-intl";
import { Currency } from "@/gql/graphql";
import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { CurrencyInput } from "@/lib/Components/Form/Inputs/CurrencyInput";
import { GenericField } from "@/lib/Components/Form/Fields/GenericField";
import { FileUploader, Upload } from "@/lib/FileUpload/FileUploader";
import { IMAGE_AND_PDF_ACCEPT } from "@/lib/FileUpload/accept";
import { Button } from "@/components/catalyst/button";
import {
  INCIDENT_UPLOAD_MAX_FILES,
  INCIDENT_UPLOAD_MAX_SIZE,
} from "@/app/Incidents/Utils/incidentUploads";

export function IncidentClaimFields({ currency }: { currency: Currency }) {
  const t = useTranslations("incident");
  const { values, setFieldValue } = useFormikContext<{
    claim_documents: Upload[];
  }>();

  return (
    <>
      <CurrencyInput
        name="excess_amount"
        label={t("claim.excessAmount")}
        description={t("claim.excessAmountHint")}
        className="col-span-4"
        currency={currency}
      />
      <TextInput
        name="insurer"
        label={t("claim.insurer")}
        className="col-span-4"
      />
      <TextInput
        name="claim_reference"
        label={t("claim.claimReference")}
        className="col-span-4"
      />
      <GenericField
        name="claim_documents"
        label={t("claim.documents")}
        description={t("claim.documentsHint")}
        className="col-span-full"
        viewNode={null}
      >
        <div className="space-y-2">
          {values.claim_documents.map((document) => (
            <div
              key={document.filePath}
              className="flex items-center justify-between gap-3 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm"
            >
              <span className="truncate">{document.file.name}</span>
              <Button
                plain
                type="button"
                onClick={() =>
                  setFieldValue(
                    "claim_documents",
                    values.claim_documents.filter(
                      (upload) => upload.filePath !== document.filePath,
                    ),
                  )
                }
              >
                {t("report.remove")}
              </Button>
            </div>
          ))}
          <FileUploader
            compact
            maxFileCount={INCIDENT_UPLOAD_MAX_FILES}
            maxSize={INCIDENT_UPLOAD_MAX_SIZE}
            accept={IMAGE_AND_PDF_ACCEPT}
            fileTypeLabel="Supports JPEG, PNG, WebP, AVIF, and PDF formats"
            onUpload={async (uploads) => {
              await setFieldValue("claim_documents", [
                ...values.claim_documents,
                ...uploads,
              ]);
            }}
          />
        </div>
      </GenericField>
    </>
  );
}
